import moment from "moment";

export function serviceValidateDateRanger(startDate, endDate) {
    if (startDate && endDate) {
        return moment.unix(endDate).diff(moment.unix(startDate), 'days') >= 0
    }
    return true
}